import React, { useEffect, useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'

import { getDefaultPermissions } from 'Selectors/account'

const Checkbox = (props) => {
  const { name, checked, indeterminate = false, description } = props
  const checkboxRef = useRef()

  useEffect(() => {
    checkboxRef.current.indeterminate = indeterminate
  }, [indeterminate])

  const handleChange = (e) => {
    props.onChange(e, name)
  }

  return (
    <label className='d-flex align-items-center'>
      <input className='mr-2' ref={checkboxRef} onChange={handleChange} type='checkbox' defaultChecked={checked} />
      {description}
    </label>
  )
}

const getPermissionCheckboxState = (permisisonName, appliedPermissions = [], allPermissions) => {
  if (permisisonName !== 'manage_users') {
    const isChecked = appliedPermissions.includes(permisisonName)

    return {
      checked: isChecked,
      indeterminate: false
    }
  }

  const userPermissions = allPermissions.filter((permission) => permission.includes('user'))
  const isChecked = userPermissions.every((permission) => appliedPermissions.includes(permission))
  const isIndeterminate = userPermissions.some((permission) => appliedPermissions.includes(permission))

  return {
    checked: isChecked,
    indeterminate: !isChecked && isIndeterminate
  }
}

const Permissions = (props) => {
  const { permissions } = props
  const { allPermissions } = useSelector(getDefaultPermissions)

  const uiPermissions = useMemo(() => {
    // Permission list to be displayed to the users

    return [
      {
        name: 'manage_users',
        description: 'Manage users',
        ...getPermissionCheckboxState('manage_users', permissions, allPermissions)
      }
      // add other permissions here.
    ]
  }, [permissions, allPermissions])

  const handlePermissionChange = (e, permissionName) => {
    const isChecked = e.target.checked
    const userPermissions = allPermissions.filter((permission) => permission.includes('user'))

    let newPermissions = [...permissions]

    if (isChecked) {
      if (permissionName === 'manage_users') {
        newPermissions.push(...userPermissions)
      } else {
        newPermissions.push(permissionName)
      }
    } else {
      if (permissionName === 'manage_users') {
        newPermissions = newPermissions.filter((permission) => !userPermissions.includes(permission))
      } else {
        const index = newPermissions.indexOf(permissionName)

        if (index > -1) {
          newPermissions.splice(index, 1)
        }
      }
    }

    props.onChange(newPermissions)
  }

  return (
    <ul>
      {uiPermissions.map((permission) => {
        return (
          <li key={'permisison_' + permission.name} className='mb-2'>
            <Checkbox
              onChange={handlePermissionChange}
              name={permission.name}
              checked={permission.checked}
              indeterminate={permission.indeterminate}
              description={permission.description}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default Permissions
